const AUTHORIZE_CALLBACK_HOSTS = {
  development: 'https://ngwecomm-dev.nexi.it',
  integration: 'https://ngwecomm-dev.nexi.it',
  staging: 'https://xpay-stg-dashboard.nexigroup.com',
  sandbox: 'https://xpaysandboxdb.nexigroup.com',
  production: 'https://xpaydashboard.nexigroup.com'
}

const getAuthorizeCallbackBaseUrl = () => {
  if (process.env.NODE_ENV !== 'development') {
    return window.location.origin
  }

  const proxyEnvironment = process.env.PROXY_ENV || process.env.FE_PROXY_ENV || 'integration'
  return AUTHORIZE_CALLBACK_HOSTS[proxyEnvironment] || AUTHORIZE_CALLBACK_HOSTS.integration
}

// Define the routes of the application
export const routesList = {
  changePassword: {
    goToChangePassword: `/changepassword`
    // @generator routes:ChangePassword:subroute
  },
  createPayByLinkPlus: {
    goToCreatePayByLinkPlus: `/createpaybylinkplus`,
    goToCreatePayByLinkPlusResult: `/createPayByLinkPlus/result`,
    goToAdvancedRequest: `/createPayByLinkPlus/advancedRequest`
    // @generator routes:CreatePayByLinkPlus:subroute
  },
  motoRoutes: {
    goToMoto: `/moto`,
    goToMotoResult: `/moto/result`
    // @generator routes:Moto:subroute
  },
  cardCheck: {
    goToCardCheck: `/cardcheck`,
    goToCardCheckResult: `/cardcheck/result`
    // @generator routes:CardCheck:subroute
  },
  bookingManagement: {
    goToBookingManagement: `/bookingmanagement`,
    goToBookingDetail: `/bookingManagement/booking/:bookingId`,
    goToCreateBookingPayByLink: `/bookingManagement/createbooking`,
    goToCreateBookingPayByLinkResult: `/bookingManagement/createbooking/result`
    // @generator routes:BookingManagement:subroute
  },

  pointsOfSales: {
    goToPointsOfSales: '/pointsofsales',
    goToPointsOfSalesDetail: (merchantId) => `/pointsofsales/PointsOfSalesDetail/${merchantId}`,
  // @generator routes:PointsOfSales:subroute
  },
  payToCard: {
    goToPayToCard: '/paytocard',
    goToPayToCardResultPage: '/paytocard/result'
    // @generator routes:PayToCard:subroute
  },
  // @generator routes:route




  // Authorized routes
  goToDashboard: `/`,
  orderManagementRoutes: {
    goToOrderManagement: `/ordermanagement`,
    goToOrderDetails: `/ordermanagement/order/:orderId`
    // @generator routes:orderManagement:subroute
  },
  operationManagement: {
    goToOperationManagement: `/operationmanagement`,
    goToOperationDetails: `/operationmanagement/operation/:operationId`
    // @generator routes:operationManagement:subroute
  },
  pblManagement: {
    goToPblManagement: `/pblmanagement`,
    goToPblManagementDetails: `/pblManagement/pblDetail/:orderId/:linkId`,
    goToNewPbl: `/createpaybylinkplus`
    // @generator routes:PblManagement:subroute
  },
  subscriptionManagementRoutes: {
    goToSubscriptionPlan: `/subscriptionplan`,
    goToSubscriptionPlanDetails: `/subscriptionplan/:orderId`
    // @generator routes:SubscriptionPlan:subroute
  },
  terminalsManagement: {
    goToTerminalsManagement: `/terminalsmanagement`,
    goToDisputelessDetails: `/terminalsmanagement/disputeless/details`,
    goToPosTokenizationDetails: `/terminalsmanagement/postokenization/details`,
    goToClickNCollectDetails: `/terminalsmanagement/clickncollect/details`,
    goToDisputelessActivation: `/terminalsmanagement/disputeless/activation`,
    goToCreateStructure: `/terminalsmanagement/disputeless/details/createStructure`,
    goToCreateTermsAndConditions: `/terminalsmanagement/disputeless/details/createTermsAndConditions`
    // @generator routes:TerminalsManagement:subroute
  },
  users: {
    goToUsers: `/users`
    // @generator routes:Users:subroute
  },
  profile: {
    goToProfile: `/profile`,
    goToChangePassword: `/profile/change-password`
  },
  reports: {
    goToReports: `/reports`
  },
  customers: {
    goToCustomers: `/customers`
  },
  stores: {
    goToStores: `/pos`,
    goToPos: `/pos`
  },

  // Unauthorized routes
  goToLogin: '/login',
  goToAuthorize: (theme) =>
    `${getAuthorizeCallbackBaseUrl()}/${theme}/authorize`,
  recoveryCredentials: {
    goToRecoveryCredentials: `/recoverycredentials`,
    goToRecoveryCredentialsResult: `/recoverycredentials/result`
    // @generator routes:recoveryCredentials:subroute
  },
  goToResetPassword: `/reset-password`, // not used
  goToExpiredSession: (theme) => theme ? `/${theme}/expired-session` : '/expired-session',
}
